export default "__VITE_ASSET__54df4179__"